import { GetContent } from '../actions/app';

export default (store) => {
    store.dispatch(GetContent());
};
